"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const react_1 = __importDefault(require("react"));
const useStyles = (0, makeStyles_1.default)(() => ({
    instructions: {
        backgroundColor: "#E5F7CE",
    },
}));
function FormInstructions({ children, }) {
    const classes = useStyles();
    return (react_1.default.createElement(material_1.Box, { p: 3, className: classes.instructions, mt: 2, mb: 2 }, children));
}
exports.default = FormInstructions;
